import React, { useState } from 'react';

//3rd party
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/nl'; // Importeer de Nederlandse locale

//Styles
import '../css/datepicker.css';

// i18n
import { useTranslations } from '../context/TranslationsContext';

const Datepicker = (props) => {
    const { t, loading: i18nLoading } = useTranslations();

    const changeDate = props.changeDate;
    const label = props.label || t('date', 'Date');
    const minDate = props.minDate ? dayjs(props.minDate) : undefined;

    const [value, setValue] = useState(dayjs(props.date));

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="nl">
        <DatePicker
          label={label}
          value={value}
          minDate={minDate}
          format="DD-MM-YYYY"
          onChange={(newValue) => {
            setValue(newValue);
            changeDate(newValue);
          }}
          slotProps={{ textField: { fullWidth: true } }}
        />
      </LocalizationProvider>
    );
}

export default Datepicker;